/**
 * Share Wishlist
 * 
 * @module share-wishlist
 * @version 1.0.0
 * @extends HTMLElement
*/

customElements.component = 'share-wishlist';

if (!customElements.get(customElements.component)) {

    class shareWishlist extends HTMLElement {

        constructor() {

            super();

            this.shareForm = this.querySelector("#share_wishlist_form");
            this.erroElement = this.querySelector('[data-share-wishlist-form-erro]');

            this.initEvents();

            this.setVisibility();            

        }

        /**
         * Init component events
         * 
         * @returns {undefined}
         */
        initEvents() {

            if(this.shareForm){

                this.shareForm.addEventListener("submit", (e) => {

                    e.preventDefault();

                    let formData = new FormData(this.shareForm);
                    let sender = formData.get("share_wishlist_sender");
                    let rec_email = formData.get("share_wishlist_rec_email");
                    let message = formData.get("share_wishlist_textarea");

                    // information required to send the email
                    let lid = null;
                    let params = {
                        toEmailId: rec_email, // To Email
                        fromName: sender, // From Name 
                        note: message,  // Note 
                        lid: lid, // null when multiple list is not enabled
                        cprops: {}, // custom props for the share, future usage
                    }

                    // Send API 
                    if(window._swat){

                        try {
                            window._swat.sendListViaEmail(params, this.onSuccess.bind(this), this.onError.bind(this));
                        }catch(e){
                            this.onError(e)
                        }

                    }else{
                        console.error("Share wishlist: _swat is now defined.");
                    }
                    
                });

            }

        }

        onSuccess(response){
            let popup =  this.querySelector("#modal_share_wishlist");
            if(popup){
                popup.close();
                this.erroElement.innerHTML = "";
                this.erroElement.classList.add('hidden');
            }
        }

        onError(error) {
            if(this.erroElement){
                this.erroElement.innerHTML = error.message;
                this.erroElement.classList.remove('hidden');
            }
        }

        setVisibility(){

            //Wishlist plus
            window.SwymCallbacks = window.SwymCallbacks || [];
            window.SwymCallbacks.push(function(){

                let onSuccess = function(lists) {
                    if(lists && lists.length > 0){
                        let productQty = lists[0].listcontents.length;
                        if(productQty > 0){
                            let shareBtn = document.querySelector('share-wishlist');
                            if(shareBtn){
                                shareBtn.classList.remove("hidden");
                            }
                            
                        }
                    }
                }

                let onError = function(error) { console.log("Error while fetching all Lists", error);}

                _swat.fetchLists({callbackFn: onSuccess, errorFn: onError});

            });

        }

    }

    customElements.define(customElements.component, shareWishlist);
}